/*
  The Vape Shop: page behaviours for the catalogue rebuild (brief 2026-10-29, Phase 3 step 2), loaded once per page
  from layout/theme.liquid.

  1. Card dropdowns close on an outside click (one document listener; it was a <script> printed in every card).
  2. Family / range headings (sections/main-collection.liquid): Horizon's infinite scroll appends each next page's
     grid items, so a page that continues the family on screen would repeat its heading; the repeat is removed.
  3. The shop selector (snippets/tvs-shop-selector.liquid; HBV's, director 2026-10-27). The chosen shop is remembered in
     this browser and applied to the collection or search grid as the Search & Discovery filter
     filter.p.m.custom.in_stock_at through Horizon's own pipeline (facets-form-component.updateFiltersByURL), so
     infinite scroll, family headings and the active-filter pill keep working. The facet itself is hidden
     (blocks/filters.liquid) and marks the grid with data-tvs-instore-facet. Removing the pill, or Clear all, sets the
     selector back to All shops. The default is All shops; nothing is chosen for the visitor. A grid without the
     filter is left alone.
  4. The staleness guard, again in the browser: when the heartbeat (meta tvs-instock-synced) is over 26 hours old the
     flags and the selector hide (html.tvs-instock-stale), so a cached page cannot show old stock.
  5. Variant states on the product page: see below.
*/
(function () {
  if (window.tvsStore) return;
  window.tvsStore = true;

  /* 1. card dropdowns */
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element) || !e.target.closest('.ve-custom-dropdown')) {
      document.querySelectorAll('.ve-custom-dropdown.ve-open').forEach(function (d) { d.classList.remove('ve-open'); });
    }
  });

  /* 2. one heading per family run */
  function dedupeHeadings() {
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      var last = null;
      Array.prototype.slice.call(grid.children).forEach(function (item) {
        if (!item.classList.contains('tvs-range-heading')) return;
        var title = item.textContent.trim();
        if (title === last) {
          item.remove();
        } else {
          last = title;
        }
      });
    });
  }
  var dedupeQueued = false;
  function queueDedupe() {
    if (dedupeQueued) return;
    dedupeQueued = true;
    window.requestAnimationFrame(function () {
      dedupeQueued = false;
      dedupeHeadings();
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    dedupeHeadings();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { queueDedupe(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });

  /* 5. variant states (director, 2026-11-02). The In store line, the option lines and "Stocked at" are rendered for the
     selected variant, so a selection swaps them from the page the picker already fetched; the two can never disagree.
     A grey value in an option line is not in the picker: its button loads that variant. */
  document.addEventListener('variant:update', function (e) {
    var data = e.detail && e.detail.data;
    if (!data || !data.html) return;
    document.querySelectorAll('[data-tvs-variant-slot]').forEach(function (slot) {
      if (slot.dataset.productId !== data.productId) return;
      var next = data.html.querySelector('[data-tvs-variant-slot="' + slot.dataset.tvsVariantSlot + '"][data-product-id="' + data.productId + '"]');
      if (next) slot.innerHTML = next.innerHTML;
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target instanceof Element ? e.target.closest('[data-tvs-variant]') : null;
    if (!b) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', b.dataset.tvsVariant);
    window.location.assign(url.toString());
  });

  /* 4. staleness guard (checked before the selector is wired) */
  var MAX_AGE_S = 26 * 3600;
  var meta = document.querySelector('meta[name="tvs-instock-synced"]');
  var synced = meta ? parseInt(meta.content, 10) : NaN;
  if (!synced || Date.now() / 1000 - synced > MAX_AGE_S) {
    document.documentElement.classList.add('tvs-instock-stale');
    document.querySelectorAll('.tvs-pick-note').forEach(function (note) {
      var input = note.closest('label').querySelector('input');
      if (input) input.setAttribute('aria-label', input.value);
    });
    return;
  }

  /* 3. shop selector */
  var PARAM = 'filter.p.m.custom.in_stock_at';
  var KEY = 'tvs-shop';

  function stored() {
    try { return window.localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }
  function store(v) {
    try {
      if (v) { window.localStorage.setItem(KEY, v); } else { window.localStorage.removeItem(KEY); }
    } catch (e) { /* private window: the choice lasts for this page only */ }
  }
  function inUrl() {
    return new URLSearchParams(window.location.search).getAll(PARAM);
  }
  function selects() {
    return document.querySelectorAll('[data-tvs-shop-select]');
  }
  function show(v) {
    selects().forEach(function (s) {
      var known = Array.prototype.some.call(s.options, function (o) { return o.value === v; });
      s.value = known ? v : '';
    });
  }
  function facetsForm() {
    return document.querySelector('facets-form-component');
  }
  function gridHasFilter() {
    return !!(facetsForm() && document.querySelector('[data-tvs-instore-facet]'));
  }
  function apply(shop) {
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    url.searchParams.delete('page');
    if (shop) url.searchParams.append(PARAM, shop);
    if (!gridHasFilter()) {
      // A search with no results at the shop draws no filters, so the shop in its URL can only change by loading the
      // page (incident 2026-11-04: "All shops" did nothing there). A grid without the filter is still left alone.
      if (inUrl().length && document.querySelector('results-list')) window.location.assign(url.toString());
      return;
    }
    var form = facetsForm();
    if (form && typeof form.updateFiltersByURL === 'function') {
      form.updateFiltersByURL(url.toString());
    } else if (window.customElements) {
      window.customElements.whenDefined('facets-form-component').then(function () {
        var f = facetsForm();
        if (f && typeof f.updateFiltersByURL === 'function') f.updateFiltersByURL(url.toString());
      });
    }
  }

  // Sold-out cards held by the chosen shop show in full colour (director, 2026-11-04: "window shop what's in stock at
  // my local store"). Each such card carries data-tvs-shops (snippets/product-card); cards added later (infinite
  // scroll, Recently viewed) are marked as they arrive.
  function chosen() {
    return inUrl()[0] || stored();
  }
  function markShop(root) {
    var shop = chosen();
    (root || document).querySelectorAll('[data-tvs-shops]').forEach(function (card) {
      var at = shop && card.getAttribute('data-tvs-shops').split('|').indexOf(shop) !== -1;
      card.classList.toggle('tvs-card--atshop', !!at);
    });
  }
  // Horizon re-renders the header after a filter change, which redraws the menu drawer's selector at All shops while
  // a shop still filters the grid; choosing All shops there then fired no change (incident 2026-11-04). So the
  // selectors are set again after every redraw (setting a value fires no change event).
  var markQueued = false;
  new MutationObserver(function () {
    show(chosen());
    if (markQueued) return;
    markQueued = true;
    window.requestAnimationFrame(function () { markQueued = false; markShop(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var s = e.target instanceof Element ? e.target.closest('[data-tvs-shop-select]') : null;
    if (!s) return;
    store(s.value);
    show(s.value);
    apply(s.value);
    markShop();
  });

  // The pill or Clear all: a removal whose target URL drops the shop filter returns the selector to All shops.
  // On window, in the capture phase: Horizon's own listener on document moves the URL first (pushState), and on
  // document this one then saw no shop in the URL and never forgot it, so the next page put it back (incident
  // 2026-11-04, phone collection pages "wrong or no results").
  function onRemove(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target instanceof Element ? e.target.closest('facet-remove-component') : null;
    if (!el || !inUrl().length || !el.dataset.url) return;
    var next = new URL(el.dataset.url, window.location.origin);
    if (!next.searchParams.getAll(PARAM).length) {
      store('');
      show('');
    }
  }
  window.addEventListener('click', onRemove, true);
  window.addEventListener('keydown', onRemove, true);
  // And after any filter change: a grid that has the shop filter but no shop in its URL means the shop was removed.
  document.addEventListener('filter:update', function () {
    if (gridHasFilter() && stored() && !inUrl().length) {
      store('');
      show('');
    }
  });

  window.addEventListener('popstate', function () { show(inUrl()[0] || ''); markShop(); });

  document.addEventListener('DOMContentLoaded', function () {
    var fromUrl = inUrl()[0] || '';
    var mine = stored();
    if (fromUrl) {
      show(fromUrl); // a shared or bookmarked link wins on this page; the remembered choice is unchanged
    } else if (mine) {
      var first = selects()[0];
      var known = first && Array.prototype.some.call(first.options, function (o) { return o.value === mine; });
      if (!known) { store(''); show(''); return; } // a shop no longer listed is forgotten, never applied
      show(mine);
      // Load the filtered page outright. Filtering after load raced the infinite scroll's first fetch, which put
      // unfiltered pages under a filtered grid and repeated products (director's report, 2026-10-31).
      if (gridHasFilter()) {
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.append(PARAM, mine);
        // Until the filtered page arrives, taps on this one would be lost in the swap (assets/tvs-store.css).
        document.documentElement.classList.add('tvs-shop-applying');
        window.location.replace(url.toString());
      }
    } else {
      show('');
    }
  });
  document.addEventListener('DOMContentLoaded', function () { markShop(); });
  window.addEventListener('pageshow', function () { document.documentElement.classList.remove('tvs-shop-applying'); });
})();
